import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/views/theme/Base"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/views/pages/Dashboard.vue"),
        },
        {
          path: "/template",
          name: "template",
          component: () =>
            import("@/views/pages/cadastros/templates/Lista.vue"),
        },
        {
          path: "/grupo",
          name: "grupo",
          component: () => import("@/views/pages/cadastros/grupos/Lista.vue"),
        },
        {
          path: "/grupo/cadastro",
          name: "grupoCadastro",
          component: () =>
            import("@/views/pages/cadastros/grupos/Cadastro.vue"),
        },
        {
          path: "/grupo/cadastro/:id",
          name: "grupoEdicao",
          component: () =>
            import("@/views/pages/cadastros/grupos/Cadastro.vue"),
        },
        {
          path: "/entidade",
          name: "entidade",
          component: () =>
            import("@/views/pages/cadastros/entidades/Lista.vue"),
        },
        {
          path: "/entidade/cadastro",
          name: "entidadeCadastro",
          component: () =>
            import("@/views/pages/cadastros/entidades/Cadastro.vue"),
        },
        {
          path: "/entidade/cadastro/:id",
          name: "entidadeEdicao",
          component: () =>
            import("@/views/pages/cadastros/entidades/Cadastro.vue"),
        },
        {
          path: "/entidade/uploads/:entidadeid",
          name: "uploads",
          component: () =>
            import("@/views/pages/cadastros/entidades/Upload.vue"),
        },

        {
          path: "/entidade/validacao/:entidadeid",
          name: "validacao",
          component: () =>
            import("@/views/pages/cadastros/entidades/Validacao.vue"),
        },
        {
          path: "/entidade/historico/:entidadeid",
          name: "entidadeHistorico",
          component: () =>
            import("@/views/pages/cadastros/entidades/Historico.vue"),
        },
        {
          path: "/usuario",
          name: "usuario",
          component: () => import("@/views/pages/cadastros/usuarios/Lista.vue"),
        },
        {
          path: "/usuario/cadastro",
          name: "usuarioCadastro",
          component: () =>
            import("@/views/pages/cadastros/usuarios/Cadastro.vue"),
        },
        {
          path: "/usuario/cadastro/:id",
          name: "usuarioEdicao",
          component: () =>
            import("@/views/pages/cadastros/usuarios/Cadastro.vue"),
        },
        {
          path: "/representante",
          name: "representante",
          component: () =>
            import("@/views/pages/cadastros/representantes/Lista.vue"),
        },
        {
          path: "/representante/cadastro",
          name: "representanteCadastro",
          component: () =>
            import("@/views/pages/cadastros/representantes/Cadastro.vue"),
        },
        {
          path: "/representante/cadastro/:id",
          name: "representanteEdicao",
          component: () =>
            import("@/views/pages/cadastros/representantes/Cadastro.vue"),
        },
        {
          path: "/cliente",
          name: "cliente",
          component: () => import("@/views/pages/cadastros/clientes/Lista.vue"),
        },
        {
          path: "/cliente/cadastro",
          name: "clienteCadastro",
          component: () =>
            import("@/views/pages/cadastros/clientes/Cadastro.vue"),
        },
        {
          path: "/cliente/cadastro/:id",
          name: "clienteEdicao",
          component: () =>
            import("@/views/pages/cadastros/clientes/Cadastro.vue"),
        },
        {
          path: "/departamento",
          name: "departamento",
          component: () =>
            import("@/views/pages/cadastros/departamentos/Lista.vue"),
        },
        {
          path: "/departamento/cadastro",
          name: "departamentoCadastro",
          component: () =>
            import("@/views/pages/cadastros/departamentos/Cadastro.vue"),
        },
        {
          path: "/departamento/cadastro/:id",
          name: "departamentoEdicao",
          component: () =>
            import("@/views/pages/cadastros/departamentos/Cadastro.vue"),
        },
        {
          path: "/empresa",
          name: "empresa",
          component: () => import("@/views/pages/cadastros/empresas/Lista.vue"),
        },
        {
          path: "/empresa/cadastro",
          name: "empresaCadastro",
          component: () =>
            import("@/views/pages/cadastros/empresas/Cadastro.vue"),
        },
        {
          path: "/empresa/cadastro/:id",
          name: "empresaEdicao",
          component: () =>
            import("@/views/pages/cadastros/empresas/Cadastro.vue"),
        },
        {
          path: "/blacklist",
          name: "blacklist",
          component: () =>
            import("@/views/pages/cadastros/blacklist/Lista.vue"),
        },
        {
          path: "/blacklist/cadastro",
          name: "blacklistCadastro",
          component: () =>
            import("@/views/pages/cadastros/blacklist/Cadastro.vue"),
        },
        {
          path: "/blacklist/cadastro/:id",
          name: "blacklistEdicao",
          component: () =>
            import("@/views/pages/cadastros/blacklist/Cadastro.vue"),
        },
        {
          path: "/documento",
          name: "documento",
          component: () =>
            import("@/views/pages/cadastros/documentos/Lista.vue"),
        },
        {
          path: "/documento/cadastro",
          name: "documentoCadastro",
          component: () =>
            import("@/views/pages/cadastros/documentos/Cadastro.vue"),
        },
        {
          path: "/documento/cadastro/:id",
          name: "documentoEdicao",
          component: () =>
            import("@/views/pages/cadastros/documentos/Cadastro.vue"),
        },
        {
          path: "/relatorios/pendencias",
          name: "relatorios",
          component: () =>
            import("@/views/pages/monitorPendencias/MonitorPendencias.vue"),
        },
        {
          path: "/relatorios/pendencias/periodo",
          name: "relatoriosPeriodo",
          component: () =>
            import(
              "@/views/pages/monitorPendencias/MonitorPendenciasAgregada.vue"
            ),
        },
        {
          path: "/relatorios/pendencias/validade",
          name: "relatoriosPeriodo",
          component: () =>
            import("@/views/pages/monitorPendencias/PendenciasValidade.vue"),
        },
        {
          path: "/relatorios/fechamento",
          name: "relatoriosFechamento",
          component: () =>
            import("@/views/pages/monitorPendencias/FechamentoMes.vue"),
        },
        {
          path: "/pendencias",
          name: "pendencias",
          component: () =>
            import("@/views/pages/acompanhamento/pendencias/Lista.vue"),
        },
        {
          path: "/logusuario",
          name: "logusuario",
          component: () =>
            import("@/views/pages/acompanhamento/logusuarios/Lista.vue"),
        },
        {
          path: "/alertas",
          name: "alertas",
          component: () =>
            import("@/views/pages/configuracoes/alertas/Configuracao.vue"),
        },
        {
          path: "/marca-documento",
          name: "marca-documento",
          component: () =>
            import(
              "@/views/pages/configuracoes/marca-documento/Configuracao.vue"
            ),
        },
        {
          path: "/perfil/cadastro",
          name: "perfilCadastro",
          component: () =>
            import("@/views/pages/cadastros/perfis/Cadastro.vue"),
        },
        {
          path: "/perfil/cadastro/:id",
          name: "perfilEdicao",
          component: () =>
            import("@/views/pages/cadastros/perfis/Cadastro.vue"),
        },
        {
          path: "/perfil",
          name: "perfil",
          component: () => import("@/views/pages/cadastros/perfis/Lista.vue"),
        },
        {
          path: "/notificacao/:id",
          name: "notificacao",
          component: () =>
            import("@/views/pages/cadastros/grupos/PageHtml.vue"),
        },
      ],
    },
    {
      path: "/",
      component: () => import("@/views/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/:cliente?",
          component: () => import("@/views/pages/auth/Login"),
        },
      ],
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/views/pages/error/Error-1.vue"),
    },
  ],
});
